import { useState } from 'react'
import { useLenis } from '../hooks/useLenis'
import { useCustomCursor } from '../hooks/useCustomCursor'
import Navigation from '../sections/Navigation'
import HeroSection from '../sections/HeroSection'
import BrandHistorySection from '../sections/BrandHistorySection'
import ShowcaseSection from '../sections/ShowcaseSection'
import CustomSection from '../sections/CustomSection'
import AiChatSection from '../sections/AiChatSection'
import OrganizationalProjectionSection from '../sections/OrganizationalProjectionSection'
import EpilogueSection from '../sections/EpilogueSection'
import Footer from '../sections/Footer'
import SvgFilters from '../sections/SvgFilters'
import Mascot from '../sections/Mascot'

export default function HomePage() {
  useLenis()
  useCustomCursor()
  const [activeService, setActiveService] = useState(0)

  const handleNavigate = (id: string, serviceIdx?: number) => {
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
      if (serviceIdx !== undefined) {
        setTimeout(() => setActiveService(serviceIdx), 400)
      }
    }
  }

  return (
    <div style={{ backgroundColor: '#fcfcfc' }}>
      <SvgFilters />
      <Navigation onNavigate={handleNavigate} />
      <main>
        <HeroSection />
        <BrandHistorySection />
        <ShowcaseSection activeService={activeService} onServiceChange={setActiveService} />
        <CustomSection />
        <AiChatSection />
        <OrganizationalProjectionSection />
        <EpilogueSection />
      </main>
      <Footer />
      <Mascot />
    </div>
  )
}
